import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import ConfirmationModal from '@components/atoms/modals/confirmation-modal.tsx';
import { useDeleteSpeaker } from '@utils/api/organizations/speakers';
import { Speaker } from '@utils/types/organization/speaker.ts';

interface DeleteSpeakerModalProps {
  isOpen: boolean;
  onClose: () => void;
  speaker: Speaker | null;
  onDeleteSuccess?: () => void;
}

export default function DeleteSpeakerModal({
  isOpen,
  onClose,
  speaker,
  onDeleteSuccess
}: DeleteSpeakerModalProps) {
  const { t } = useTranslation();
  const deleteMutation = useDeleteSpeaker();

  const handleConfirm = async () => {
    if (!speaker) return;

    try {
      await deleteMutation.mutateAsync(speaker.id);
      toast.success(t('speaker-deleted-successfully'));
      onDeleteSuccess?.();
      onClose();
    } catch {
      toast.error(t('failed-to-delete-speaker'));
    }
  };

  if (!speaker) return null;

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={t('delete-speaker')}
      caption={t('confirm-delete-speaker', { name: speaker.name })}
      confirmLabel={t('delete')}
      cancelLabel={t('cancel')}
      destructive
      confirmDisabled={deleteMutation.isLoading}
    />
  );
}
